export default __webpack_public_path__ + "static/media/hear3.7124ed95.svg";